import { FunctionComponent } from 'react'
import { Translation } from '@dxp-module/common'
import Typography from '@mui/material/Typography'
import Button, { ButtonProps } from '@mui/material/Button'
import PlusIcon from '@mui/icons-material/AddCircleOutline'
import addButtonStyles from './addButton.styles'

type AddButtonProps = ButtonProps & {
  translationId: string
}

const AddButton: FunctionComponent<AddButtonProps> = ({
  translationId,
  ...props
}) => {
  const styles = addButtonStyles()

  return (
    <Button
      {...props}
      variant="text"
      className={styles.button}
      data-test="form:array:add:button"
    >
      <PlusIcon />
      <Typography variant="caption" className={styles.caption}>
        <Translation
          id={translationId}
          component="Typography"
          componentProps={{ variant: 'button' }}
        />
      </Typography>
    </Button>
  )
}

export default AddButton
